import React from 'react';
import Layout from '../../layout';






function Ourpillars() {
  return (
   <Layout>
      <section class="page-header padding">
           <div class="overlay"></div>
            <div class="container">
               <div class="section-heading mt-40 text-center">
                    <h4 class="sub-heading">Our Leadership</h4>
                    <h2>Derm Group Leadership and<br/> Management Team</h2>
                    <p>Construction is a general term meaning the art and science to <br/>form objects systems organizations.</p>
                </div>
            </div>
        </section>
        <section class="about-section padding bd-bottom">
            <div class="container">
                <div class="row d-flex align-items-center">
                    <div class="col-md-6 sm-padding wow fadeInLeft" data-wow-delay="200ms">
                        <div class="section-heading sectionceo mb-30">
                            <h2>Message from our Group <span>Chairman</span></h2>
                            <p>For 20 years now, Derm Group has been involved in many major construction and engineering projects – gaining invaluable experience and expertise, and acquiring a reputation as one of the leading electrical contractors in Tanzania.</p>
                            <p>We have successfully completed many high-profile contracts, in both the private and the public sectors, where our on-time, in-budget performance and our stringent technical standards have demonstrated our total commitment to every aspect of our operations. I am proud to be at the head of a skilled and dedicated team of engineers, managers and support staff.</p>
                            <p>My aim is to ensure the ongoing success of the company by developing their talents and abilities, and by expanding our activities into ever-more technically challenging fields.</p>
                            <p>I relish the prospect of taking the company forward in this increasingly demanding and competitive world by building on our special core values and skills.</p>
                            <p>Above all, I am determined that Derm Group will maintain its reputation for quality and reliability.</p>
                        </div>
                        {/* <div class="row d-flex align-items-center">
                            <div class="col-md-6">
                                <div class="about-list">
                                    <div class="about-icon">
                                        <i class="dl dl-levels"></i>
                                    </div>
                                    <div class="about-content">
                                        <h3>Industrus Mission</h3>
                                        <p>Construction is a general term meaning the art and science to form objects systems.</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="about-list">
                                    <div class="about-icon">
                                        <i class="dl dl-industrial-robot-8"></i>
                                    </div>
                                    <div class="about-content">
                                        <h3>Our Vision</h3>
                                        <p>Construction is a general term meaning the art and science to form objects systems.</p>
                                    </div>
                                </div>
                            </div>
                        </div> */}
                        <div class="sign">
                            {/* <a href="about.html" class="default-btn">More about us <span></span></a> */}
                            <h4>
                                <h4 class="sub-heading" style={{fontSize: 28, marginBottom: 0, fontFamily: 'GothamBold' }}>Eng. Ridhuan Mringo</h4><br/>
                            <h4 class="sub-heading" style={{fontSize: 23, marginTop: 0}}> Group Chairman</h4>
                                </h4>
                            {/* <img src="assets/img/sign.png" alt="sign"/> */}
                        </div>
                    </div>
                    <div class="col-md-6 sm-padding wow fadeInRight" data-wow-delay="200ms">
                        <div class="about-img">
                            <img src="https://res.cloudinary.com/dedfrilse/image/upload/v1700406474/derma/vdpc73cwijfcbz7ki1tl.jpg" alt=""/>
                            {/* <div class="exp-box">
                                <h3>25 Years Of <br/>Experiences</h3>
                            </div> */}
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="team-section-2" style={{backgroundColor: '#eeeeee', paddingTop: 100}}>
           {/* <div class="overlay"></div> */}
            <div class="container">
                <div class="section-heading mb-40 text-center wow fadeInUp" data-wow-delay="200ms">
                    {/* <h4 class="sub-heading">Leadership team</h4> */}
                    <h2>Management <span>Team</span></h2>
                    <p style={{color: '#3F3C3A', fontSize: 16}}>Construction is a general term meaning the art and science to <br/>form objects systems organizations.</p>
                </div>
                <div class="row">
                    <div class="col-lg-3 col-md-6 sm-padding">
                        <div class="team-box">
                            <div class="team-thumb">
                                <img src="https://res.cloudinary.com/dedfrilse/image/upload/v1700584600/derma/gby9a5t4mxoubzvrz9bu.png" alt="team"/>
                                <div class="team-content">
                                    <h3>Eng. Arnold Samugabo <span>Managing Director</span></h3>
                                </div>
                                {/* <ul class="team-social">
                                    <li class=""><a href="#"><i class="fab fa-facebook-f"></i></a></li>
                                    <li><a href="#"><i class="fab fa-twitter"></i></a></li>
                                    <li><a href="#"><i class="fab fa-instagram"></i></a></li>
                                    <li><a href="#"><i class="fab fa-linkedin"></i></a></li>
                                </ul> */}
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 sm-padding">
                        <div class="team-box">
                            <div class="team-thumb">
                                <img src="https://res.cloudinary.com/dedfrilse/image/upload/v1700405716/derma/ud0sseak7eephnmmxv0g.png" alt="team"/>
                                <div class="team-content">                           
                                    <h3>Eng. Peter Mwanga <span>Managing Director - Concrete</span></h3>
                                </div>
                                {/* <ul class="team-social">
                                    <li><a href="#"><i class="fab fa-facebook-f"></i></a></li>
                                    <li><a href="#"><i class="fab fa-twitter"></i></a></li>
                                    <li><a href="#"><i class="fab fa-instagram"></i></a></li>
                                    <li><a href="#"><i class="fab fa-linkedin"></i></a></li>
                                </ul> */}
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 sm-padding">
                        <div class="team-box">
                            <div class="team-thumb">
                                <img src="https://res.cloudinary.com/dedfrilse/image/upload/v1700405715/derma/chd6oheelmndwhgkhmqm.png" alt="team"/>
                                <div class="team-content">
                                    <h3>Eng. Iddi Bakari<span>Director of Medium Voltage</span></h3>
                                </div>
                                {/* <ul class="team-social">
                                    <li><a href="#"><i class="fab fa-facebook-f"></i></a></li>
                                    <li><a href="#"><i class="fab fa-twitter"></i></a></li>
                                    <li><a href="#"><i class="fab fa-instagram"></i></a></li>
                                    <li><a href="#"><i class="fab fa-linkedin"></i></a></li>
                                </ul> */}
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 sm-padding">
                        <div class="team-box">
                            <div class="team-thumb">
                                <img src="https://res.cloudinary.com/dedfrilse/image/upload/v1700584601/derma/micfmgjtlal0qdxtbpnl.png" alt="team"/>
                                <div class="team-content">
                                    <h3>Bridget B. Temba <span>Commercial Director</span></h3>
                                </div>
                                {/* <ul class="team-social">
                                    <li><a href="#"><i class="fab fa-facebook-f"></i></a></li>
                                    <li><a href="#"><i class="fab fa-twitter"></i></a></li>
                                    <li><a href="#"><i class="fab fa-instagram"></i></a></li>
                                    <li><a href="#"><i class="fab fa-linkedin"></i></a></li>
                                </ul> */}
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 sm-padding">
                        <div class="team-box">
                            <div class="team-thumb">
                                <img src="https://res.cloudinary.com/dedfrilse/image/upload/v1700584601/derma/iukp4hjpcnpk40vzmlme.png" alt="team"/>
                                <div class="team-content">
                                    <h3>Winifrida B. Lekule <span>Human Resource Manager - Group</span></h3>
                                </div>
                                {/* <ul class="team-social">
                                    <li><a href="#"><i class="fab fa-facebook-f"></i></a></li>
                                    <li><a href="#"><i class="fab fa-twitter"></i></a></li>
                                    <li><a href="#"><i class="fab fa-instagram"></i></a></li>
                                    <li><a href="#"><i class="fab fa-linkedin"></i></a></li>
                                </ul> */}
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 sm-padding">
                        <div class="team-box">
                            <div class="team-thumb">
                                <img src="https://res.cloudinary.com/dedfrilse/image/upload/v1700405718/derma/d3z2knzjnqi1grwsx36r.png" alt="team"/>
                                <div class="team-content">
                                    <h3>Venance John <span>Chief Accountant - Group</span></h3>
                                </div>
                                {/* <ul class="team-social">
                                    <li><a href="#"><i class="fab fa-facebook-f"></i></a></li>
                                    <li><a href="#"><i class="fab fa-twitter"></i></a></li>
                                    <li><a href="#"><i class="fab fa-instagram"></i></a></li>
                                    <li><a href="#"><i class="fab fa-linkedin"></i></a></li>
                                </ul> */}
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 sm-padding">
                        <div class="team-box">
                            <div class="team-thumb">
                                <img src="https://res.cloudinary.com/dedfrilse/image/upload/v1700405718/derma/vkjqo5hwteojyjckh01g.png" alt="team"/>
                                <div class="team-content">
                                    <h3>Coordinator Name <span>Coordinator - Skyline Properties</span></h3>
                                </div>
                               
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 sm-padding">
                        <div class="team-box">
                            <div class="team-thumb">
                                <img src="https://res.cloudinary.com/dedfrilse/image/upload/v1700582936/derma/huidkt1qxgzsmlajwhnf.png" alt="team"/>
                                <div class="team-content">
                                    <h3>Mohammed Mgori <span>Marketing & PR Manager</span></h3>
                                </div>
                               
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
      
   </Layout>
  );
}

export default Ourpillars;